import { ReduxStorageUtils } from '@cuatroochenta/co-redux-builders';
import { push } from 'react-router-redux';
import { generateRoute } from '../commons/utils/Router';

export function goToRoute(route: string, params: object = {}): void {
    const routeWithParams = generateRoute(route, params);
    ReduxStorageUtils.dispatch(push(routeWithParams));
}
